import { useTranslation } from 'react-i18next';
import { SttFormSelect } from '../all';

type Props = {
    name: string;
    defVal: string;
    onChange: (event: { name: string | undefined; value: unknown }) => void;
    [key: string]: unknown;
};

export function SttSelectUnlockerType({
    name,
    defVal,
    onChange,
    ...rest
}: Props): React.ReactElement {
    const { t } = useTranslation();

    return (
        <SttFormSelect
            caption={t('labels.type')}
            name={name}
            defVal={defVal}
            {...rest}
            options={[
                {
                    caption: t('accessTypes.card'),
                    value: 'CARD',
                },
                {
                    caption: t('accessTypes.pin'),
                    value: 'PIN',
                },
                {
                    caption: t('accessTypes.qr'),
                    value: 'QR',
                },
            ]}
            onChange={onChange as any}
            mandatory
        />
    );
}

/*
define("_UT_TICKET_ONE_USE", 'TICKET_ONE_USE');
define("_UT_TICKET_CARD", 'TICKET_CARD');
define("_UT_CARD", 'CARD');
define("_UT_FINGERPRINT", 'FINGERPRINT');
define("_UT_PIN", 'PIN');
* */

/*
 * Props
 *
 *     * bool grid - wrap the element into a <Grid>
 *     * Array options - options as an array of {caption, value}
 *     * <any> defVal - the currently selected value
 *     * boolean cleanable: if it's true, a clean button (X) is added to reset the selection.
 *     * string name - the field name
 *     * string caption - the field caption (top label & placeholder text)
 *     * Function onChange - callback when the selected value changes
 *     * bool disabled
 *     * bool mandatory - if mandatory, the value cannot be de-selected
 */
